import { combineReducers } from 'redux';
import {
  ITALIAN_ORDER_PRICE_ENTRIES_REQUEST,
  ITALIAN_ORDER_PRICE_ENTRIES_SUCCESS,
  ITALIAN_ORDER_PRICE_ENTRIES_FAILED,
  FOREIGN_ORDER_PRICE_ENTRIES_REQUEST,
  FOREIGN_ORDER_PRICE_ENTRIES_SUCCESS,
  FOREIGN_ORDER_PRICE_ENTRIES_FAILED,
  REQUEST_PRICE_LIST_DEFAULT_START,
  REQUEST_PRICE_LIST_DEFAULT_SUCCESS,
  REQUEST_PRICE_LIST_DEFAULT_ERROR,
} from '../actions';

function entries(state = [], action) {
  switch (action.type) {
    case ITALIAN_ORDER_PRICE_ENTRIES_REQUEST:
    case ITALIAN_ORDER_PRICE_ENTRIES_FAILED:
    case FOREIGN_ORDER_PRICE_ENTRIES_REQUEST:
    case FOREIGN_ORDER_PRICE_ENTRIES_FAILED:
      return [];
    case ITALIAN_ORDER_PRICE_ENTRIES_SUCCESS:
    case FOREIGN_ORDER_PRICE_ENTRIES_SUCCESS:
      return Object.assign([], action.entries);
    default:
      return Object.assign([], state);
  }
}

function loading(state = false, action) {
  switch (action.type) {
    case ITALIAN_ORDER_PRICE_ENTRIES_REQUEST:
    case FOREIGN_ORDER_PRICE_ENTRIES_REQUEST:
      return true;
    case ITALIAN_ORDER_PRICE_ENTRIES_FAILED:
    case ITALIAN_ORDER_PRICE_ENTRIES_SUCCESS:
    case FOREIGN_ORDER_PRICE_ENTRIES_FAILED:
    case FOREIGN_ORDER_PRICE_ENTRIES_SUCCESS:
      return false;
    default:
      return state;
  }
}

function availableCredits(state = null, action) {
  switch (action.type) {
    case ITALIAN_ORDER_PRICE_ENTRIES_SUCCESS:
    case FOREIGN_ORDER_PRICE_ENTRIES_SUCCESS:
      return action.availableCredits;
    case ITALIAN_ORDER_PRICE_ENTRIES_REQUEST:
    case ITALIAN_ORDER_PRICE_ENTRIES_FAILED:
    case FOREIGN_ORDER_PRICE_ENTRIES_REQUEST:
    case FOREIGN_ORDER_PRICE_ENTRIES_FAILED:
      return null;
    default:
      return state;
  }
}

function defaultPriceList(state = {}, action) {
  switch (action.type) {
    case REQUEST_PRICE_LIST_DEFAULT_START:
      return Object.assign({}, state, {
        isFetching: true,
        errorMsg: '',
      });

    case REQUEST_PRICE_LIST_DEFAULT_SUCCESS: {
      const list = Object.keys(action.data).map(key => action.data[key]);
      return Object.assign({}, state, {
        isFetching: false,
        errorMsg: '',
        data: action.data,
        list,
      });
    }

    case REQUEST_PRICE_LIST_DEFAULT_ERROR:
      return Object.assign({}, state, {
        isFetching: false,
        errorMsg: action.err.message || process.env.ERR_GENERIC,
      });

    default:
      return state;
  }
}

const priceList = combineReducers({
  entries,
  loading,
  availableCredits,
  defaultPriceList,
});

export default priceList;
